import { regular } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { Translate } from "react-i18nify";
import styles from "./InformativeCard.module.css";

const InformativeCard = ({ shouldOverlay, left }: InformativeCardProps): JSX.Element => {
    const classes = classNames(
        styles.container,
        "column",
        "has-text-left",
        "px-6",
        "py-5",
        "is-size-5-fullhd",
        "is-size-7",
        shouldOverlay ? styles.overlay : "",
        left ? styles.left : ""
    );

    return (
        <div className={classes}>
            <div className="has-text-primary-blue has-text-weight-bold">
                <div>
                    <Translate value="assessments.duration" />
                </div>
                <div className="has-text-weight-bold">
                    <FontAwesomeIcon icon={regular("clock")} />{" "}
                    <span>
                        <Translate value="assessments.15min" />
                    </span>
                </div>
            </div>
            <div className="content has-text-dark-blue has-text-weight-semibold">
                <div className="my-3">
                    <Translate value="assessments.pleaseBeSure" />
                </div>
                <ul>
                    <li>
                        <Translate value="assessments.turnOffPhone" />
                    </li>
                    <li>
                        <Translate value="assessments.wearGlasses" />
                    </li>
                    <li>
                        <Translate value="assessments.restroom" />
                    </li>
                </ul>
                <div className="my-3">
                    <Translate value="assessments.beComfortable" />
                </div>
            </div>
        </div>
    );
};

export default InformativeCard;

interface InformativeCardProps {
    shouldOverlay?: boolean;
    left?: boolean;
}
